module.exports = __webpack_public_path__ + "static/media/Huset.d15e3a9d.jpg";